import { render, staticRenderFns } from "./syncInfoYmsModal.vue?vue&type=template&id=ad8654b8&scoped=true&"
import script from "./syncInfoYmsModal.vue?vue&type=script&lang=js&"
export * from "./syncInfoYmsModal.vue?vue&type=script&lang=js&"
import style0 from "./syncInfoYmsModal.vue?vue&type=style&index=0&id=ad8654b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8654b8",
  null
  
)

export default component.exports